import { isFeature } from 'Cloud/Application/FeaturesEs6';

/**
 * @see https://jira.vk.team/browse/CLOUDWEB-18769
 */
export const SHARING_REDESIGN_BIZ = isFeature('sharing-redesign-biz');

export const SHARING_FOLDERS_REDESIGN_BIZ = isFeature('sharing-folders-redesign-biz');
